type CsvCell = string | number | boolean;
type CsvRow = Record<string, CsvCell>;

const escapeCell = (value: CsvCell): string => `"${String(value).replace(/"/g, '""')}"`;

/**
 * Build a CSV string from an array of flat records. The column order and header
 * come from the keys of the first row. Every cell is quoted and quote-escaped so
 * commas, quotes and newlines are safe. Returns "" for an empty array.
 */
export function rowsToCsv(rows: CsvRow[]): string {
  if (rows.length === 0) return "";
  const headers = Object.keys(rows[0]);
  const headerLine = headers.map((h) => escapeCell(h)).join(",");
  const bodyLines = rows.map((row) => headers.map((h) => escapeCell(row[h] ?? "")).join(","));
  return [headerLine, ...bodyLines].join("\r\n");
}

/**
 * Trigger a client-side CSV download. No-op when there is nothing to export.
 */
export function downloadCsv(filename: string, rows: CsvRow[]): void {
  if (rows.length === 0) return;
  const blob = new Blob([rowsToCsv(rows)], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
